var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconGitlabLogo = function SvgIconGitlabLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.474 9.5 6.6 4.496l-.003-.007a1.375 1.375 0 0 0-2.612.137l-2.57 9.61-.005.022a1.77 1.77 0 0 0 .69 1.855l.013.01L11 22.272a1.76 1.76 0 0 0 1.998 0l8.888-6.15.013-.01a1.77 1.77 0 0 0 .69-1.855l-.006-.023-2.568-9.609a1.375 1.375 0 0 0-2.613-.137l-.002.007L15.525 9.5zM5.412 7.028l-2.018 7.55 6.544 4.528zm8.649 12.078 6.545-4.529-2.018-7.549zm-2.061-.2 2.776-7.406H9.224z",
    clipRule: "evenodd"
  })));
};
export default SvgIconGitlabLogo;